module.exports = __webpack_public_path__ + "static/media/verhaltensbasiert_step_6_neg.9d44b557.png";